import { ActionBarSpacer } from "$components/action-bar/action-bar-spacer";
import { Page } from "$components/page";
import { makeStyles } from "@material-ui/core";
import { InventoryActionBar } from "./_lib/inventory-action-bar";
import {
  InventoryContextProvider,
  useMoveDrawerContext,
  useReceiveDrawerContext,
} from "./_lib/inventory-context";
import { InventoryOverview } from "./_lib/inventory-overview";
import { MoveDrawer } from "./_lib/move-drawer/move-drawer";
import { ReceiveDrawer } from "./_lib/receive-drawer/receive-drawer";
import { DRAWER_WIDTH } from "./_lib/side-drawer";

const styles = makeStyles((theme) => ({
  content: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // Only shift where the drawer docks alongside (it overlays on small screens).
    [theme.breakpoints.up("md")]: {
      marginLeft: DRAWER_WIDTH,
      // The column is now ~65% wide, but media queries key off the viewport
      // (still lg/md) not this element, so Page keeps its full-width gutters.
      // Drop them so the narrowed content isn't squeezed by big side borders.
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  },
}));

const InventoryBody = (): JSX.Element => {
  const classes = styles();
  const { isOpen: receiveDrawerOpen } = useReceiveDrawerContext();
  const { isOpen: moveDrawerOpen } = useMoveDrawerContext();
  const isDrawerOpen = receiveDrawerOpen || moveDrawerOpen;

  return (
    <Page className={isDrawerOpen ? classes.contentShift : classes.content}>
      <InventoryOverview />
      <ActionBarSpacer />
    </Page>
  );
};

const InventoryManagementPage = (): JSX.Element => {
  return (
    <InventoryContextProvider>
      <ReceiveDrawer />
      <MoveDrawer />
      <InventoryBody />
      <InventoryActionBar />
    </InventoryContextProvider>
  );
};

export default InventoryManagementPage;
